import { create } from 'zustand'

import type { Card } from '~/db/types'

export type FadingCardSnapshot = Pick<
  Card,
  | 'examples'
  | 'id'
  | 'learnText'
  | 'pronunciation'
  | 'snoozeCountSource'
  | 'snoozeCountLearn'
  | 'snoozedUntilSource'
  | 'snoozedUntilLearn'
  | 'sourceText'
> & {
  deltaX: number
  deltaY: number
  rotate: number
  scale: number
}

type FadingCardState = {
  fadingCard: FadingCardSnapshot | null
}

type FadingCardActions = {
  clearFadingCard: () => void
  startFadingCard: (fadingCard: FadingCardSnapshot) => void
}

export const useFadingCardStore = create<FadingCardState & FadingCardActions>()(set => ({
  fadingCard: null,
  clearFadingCard: () => set({ fadingCard: null }),
  startFadingCard: fadingCard => set({ fadingCard }),
}))
